<div class="filter-row">
  <hau-form [formGroup]="filterForm()">
    <div class="filter-group">
      <div class="filter-control-group">
        <hau-form-field label="Interner Tenant">
          <wr-tenant-select [tenantType]="'Internal'" formControlName="internalTenantId"></wr-tenant-select>
        </hau-form-field>
      </div>
      @if (filterForm().controls.internalTenantId.value) {
        <div class="filter-control-group">
          <hau-form-field label="Prüfpunkt">
            <wr-checkpoint-select
              [tenantId]="filterForm().controls.internalTenantId.value"
              formControlName="checkpointId">
            </wr-checkpoint-select>
          </hau-form-field>
        </div>
      }
      @if (currentTenant()?.type === 'Internal') {
        <div class="filter-control-group">
          <hau-form-field label="Kunde">
            <wr-tenant-select [tenantType]="'External'" formControlName="externalTenantId"></wr-tenant-select>
          </hau-form-field>
        </div>
      }
      <div class="filter-control-group">
        <hau-form-field label="Gebäude">
          <wr-building-multi-select
            [tenantId]="filterForm().controls.externalTenantId.value"
            (selectionChange)="onBuildingsChange($event)">
          </wr-building-multi-select>
        </hau-form-field>
      </div>
      @if (filterForm().controls.internalTenantId.value) {
        <div class="filter-control-group">
          <hau-form-field label="Maßnahme">
            <wr-action-select
              [tenantId]="filterForm().controls.internalTenantId.value"
              [additionalActions]="availableActions()"
              formControlName="action"
              [showAllOption]="true">
            </wr-action-select>
          </hau-form-field>
        </div>
        <div class="filter-control-group">
          <hau-form-field label="Gruppieren nach">
            <nb-select fullWidth formControlName="groupBy" placeholder="Keine Gruppierung">
              <nb-option [value]="undefined">Keine Gruppierung</nb-option>
              @for (option of groupByOptions; track option.value) {
                <nb-option [value]="option.value">{{ option.label }}</nb-option>
              }
            </nb-select>
          </hau-form-field>
        </div>
      }
    </div>
  </hau-form>
  <button class="export-button" nbButton status="primary" (click)="exportAllPdf()"
          [disabled]="exporting()"
          [nbSpinner]="exporting()"
          nbSpinnerStatus="primary"
          nbSpinnerSize="small">
    <nb-icon pack="fas" icon="file-pdf"></nb-icon>
    PDF Export
  </button>
</div>

<div class="results" [nbSpinner]="loading()">
  @if (filterForm().controls.internalTenantId.value && filterForm().controls.checkpointId.value) {
    <div class="sort-header">
      @for (column of sortableColumns; track column.key) {
        <div class="sort-header-cell" role="button" tabindex="0"
             (click)="toggleSort(column.key)" (keydown.enter)="toggleSort(column.key)">
          <span>{{ column.label }}</span>
          @if (sort()?.sort === column.key) {
            <nb-icon pack="eva" [icon]="sort()?.order === 'ASC' ? 'arrow-ios-downward' : 'arrow-ios-upward'"></nb-icon>
          }
        </div>
      }
      <div class="sort-header-cell static">TGA</div>
    </div>
    @if (filterForm().controls.groupBy.value) {
      @if (groups().length) {
        <div class="grouped-results">
          @for (group of groups(); track group.key) {
            <div class="group-header" role="button" tabindex="0"
                 (click)="toggleGroup(group.key)" (keydown.enter)="toggleGroup(group.key)">
              <nb-icon pack="eva" [icon]="isCollapsed(group.key) ? 'chevron-right-outline' : 'chevron-down-outline'"></nb-icon>
              <span class="group-name">{{ group.name }}</span>
              <span class="group-count">{{ group.count }}</span>
            </div>
            @if (!isCollapsed(group.key)) {
              <div class="group-entries">
                @for (entry of group.entries; track entry.id) {
                  <div class="group-entry" role="button" tabindex="0"
                       (click)="openDialog(entry)" (keydown.enter)="openDialog(entry)">
                    <ng-container [ngTemplateOutlet]="entryRow" [ngTemplateOutletContext]="{ $implicit: entry }"></ng-container>
                  </div>
                }
              </div>
            }
          }
        </div>
      } @else if (groupedLoadError()) {
        <div class="empty-hint">
          <nb-icon pack="eva" icon="alert-triangle-outline"></nb-icon>
          <span>{{ groupedLoadError() }}</span>
          <button nbButton outline status="basic" size="tiny" (click)="reset()">Erneut laden</button>
        </div>
      } @else if (!loading()) {
        <ng-container [ngTemplateOutlet]="emptyHint"></ng-container>
      }
    } @else if (entries().length) {
      <wr-list-view
        [items]="entries()"
        [showSearch]="false"
        [canCreate]="false"
        (selectedChange)="openDialog($event)"
        (scrolledToEnd)="loadMore()">
        <ng-template wrListItem let-entry>
          <ng-container [ngTemplateOutlet]="entryRow" [ngTemplateOutletContext]="{ $implicit: entry }"></ng-container>
        </ng-template>
      </wr-list-view>
      @if (loadingMore()) {
        <div class="loading-more">
          <nb-icon pack="fas" icon="spinner"></nb-icon>
          <span>Weitere Einträge werden geladen…</span>
        </div>
      }
    } @else if (!loading()) {
      <ng-container [ngTemplateOutlet]="emptyHint"></ng-container>
    }
  } @else {
    <div class="empty-hint">
      <nb-icon pack="eva" icon="info-outline"></nb-icon>
      <span>Bitte wählen Sie einen internen Tenant und einen Prüfpunkt aus, um die zugehörigen Prüfpunktzeilen anzuzeigen.</span>
    </div>
  }
</div>

<ng-template #entryRow let-entry>
  <div class="entry-row">
    <span class="entry-address">{{ entry.sectionText }}</span>
    <span class="entry-date">{{ entry.inspectionSendingTimestamp ? (entry.inspectionSendingTimestamp | date: 'dd.MM.yyyy') : '–' }}</span>
    <span class="entry-deadline">{{ entry.deadline ? (entry.deadline | deadlineTranslation) : '–' }}</span>
    <span class="entry-action">{{ entry.action?.name ?? '–' }}</span>
    <span class="tga-count">{{ entry.buildingEquipmentCount }} TGA</span>
  </div>
</ng-template>

<ng-template #emptyHint>
  <div class="empty-hint">
    <nb-icon pack="eva" icon="slash-outline"></nb-icon>
    <span>Keine Einträge für die gewählten Filter gefunden.</span>
  </div>
</ng-template>
